import { fn } from '@ember/helper';
import { action } from '@ember/object';
import { getOwner } from '@ember/owner';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismCheckbox,
  PrismComboSelectInput,
  PrismInput,
  PrismSelectInput,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import Countries from 'frontend-utils/utils/countries';
import GeneralFormFieldsCancelAndConfirm from 'lumen/components/general/form-fields/cancel-and-confirm';
import GeneralFormsFormFieldsDatepickerFormField from 'lumen/components/general/forms/form-fields/datepicker-form-field';
import { CHANNEL_PLATFORM } from 'lumen/components/parity/parity-manager/channel-rate-form';
import ParityParityManagerIssueDetailHotelInMarketSearch from 'lumen/components/parity/parity-manager/issue-detail-hotel-in-market-search';

const BASE_PLATFORM = 'base_platform';

const RATE_TYPE_OPTIONS = [
  { id: 'lowest', name: 'rates.lowest' },
  { id: 'nonrefundable', name: 'rates.nonrefundable' },
  { id: 'bar', name: 'rates.bar_short' },
];

interface ParityParityManagerHotelRateFormSignature {
  Args: {
    cancel: unknown;
    currencyCode: unknown;
    isMajorOtaView: unknown;
    issue: unknown;
    next: unknown;
    platformOptions: unknown;
    setIssueProperty: unknown;
    setIssuePropertyFromEvent: unknown;
    toggleValue: unknown;
  };
}

export default class ParityParityManagerHotelRateForm extends Component<ParityParityManagerHotelRateFormSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // @ts-expect-error: Incorrect type
  countries = new Countries(getOwner(this));

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isBaseRateValid() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-return
    return this.issueBaseRate && parseFloat(this.issueBaseRate) > 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isFormValid() {
    // @ts-expect-error: Incorrect type
    const { arrival_date: arrivalDate, los, pos } = this.args.issue;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      arrivalDate &&
      los &&
      pos &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.issueSubscription?.id &&
      this.isBaseRateValid
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get issueBaseRate() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.issue?.base_rate;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get issueSubscription() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.issue?.subscription;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get losValue() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.losOptions.find((option) => option.los === this.args.issue.los);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get minDate() {
    return this.hotelAndMarketService.getLocalTime();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get posValue() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.posOptions.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (option) => option.country.id === this.args.issue.pos.id,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedPlatform() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.platformOptions.find(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (option) => option.id === this.args.issue[BASE_PLATFORM],
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get timezone() {
    return this.hotelAndMarketService.timezone;
  }

  constructor() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    const losOptions = [];
    for (let i = 1; i <= 30; i++) {
      losOptions.push({ label: i, los: i });
    }

    // @ts-expect-error: Incorrect type
    this.losOptions = losOptions;

    // @ts-expect-error: Incorrect type
    this.posOptions = this.countries.list.map((country) => ({
      label: country.name,
      country,
    }));
    // @ts-expect-error: Incorrect type
    this.rateOptions = RATE_TYPE_OPTIONS;
    // @ts-expect-error: Incorrect type
    this.args.issue.rate = RATE_TYPE_OPTIONS[0];
  }

  @action
  // @ts-expect-error: Incorrect type
  hasSelectedSubscription(selectedOption): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!selectedOption.subscription.id) {
      // It's possible no matches were found. In that case the autocomplete will contain the searchText
      // It's seen as "valid" while we need an actual sub
      // So if you move away from the sub autocomplete, but have not actually chosen a sub, we'll clear it
      // @ts-expect-error: Incorrect type
      this.args.setIssueProperty('subscription', '');
    } else {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.args.setIssueProperty('subscription', selectedOption.subscription);
    }
  }

  @action
  onCloseArrivalDate(): void {
    // @ts-expect-error: Incorrect type
    this.isStartFocused = false;
    // @ts-expect-error: Incorrect type
    if (!this.args.issue?.arrival_date) {
      // @ts-expect-error: Incorrect type
      this.openNoStartDate = true;
    } else {
      // @ts-expect-error: Incorrect type
      this.openNoStartDate = false;
    }
  }

  @action
  onOpenArrivalDate(): void {
    // @ts-expect-error: Incorrect type
    this.isStartFocused = true;
  }

  @action
  // @ts-expect-error: Incorrect type
  onSelectionArrivalDate(value): void {
    if (value) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.args.setIssueProperty('arrival_date', value.format('YYYY-MM-DD'));
    } else {
      // @ts-expect-error: Incorrect type
      this.args.setIssueProperty('arrival_date', value);
    }
  }

  @action
  // @ts-expect-error: Incorrect type
  setSelectedPlatformId(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty(BASE_PLATFORM, option.id);
    // Use BASE_PLATFORM as default for CHANNEL_PLATFORM in next step
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty(CHANNEL_PLATFORM, option.id);
  }

  // @ts-expect-error: Incorrect type
  @action updateBaseRoomName(event): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('base_room_name', event.target.value);
  }

  // @ts-expect-error: Incorrect type
  @action updateLos(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('los', option.los);
  }

  // @ts-expect-error: Incorrect type
  @action updatePos(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.setIssueProperty('pos', option.country);
  }

  <template>
    <div class="flex flex-col p-500" id="add-issue-form">
      <h2 class="header-title pb-400">
        {{t "parity_manager.add_issue.hotel_rate_info"}}
      </h2>
      <div class="flex">
        <div class="flex w-full flex-col pb-400">
          <label class="input-label required-indicator">
            {{t "parity_manager.hotel"}}
          </label>

          <ParityParityManagerIssueDetailHotelInMarketSearch
            @selectItem={{this.hasSelectedSubscription}}
            {{! @glint-expect-error: Incorrect type }}
            @selectedOption={{@issue.subscription}}
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-400">
        <PrismInput
          @errorMessage={{t "parity_manager.validation.base_rate"}}
          @hasErrors={{not this.isBaseRateValid}}
          {{! @glint-expect-error: Incorrect type }}
          @inlineLabel={{@currencyCode}}
          @label={{t "parity.base_rate"}}
          {{! @glint-expect-error: Incorrect type }}
          @onInput={{fn @setIssuePropertyFromEvent "base_rate"}}
          @required={{true}}
          @requiredErrorMessage={{t "general.required"}}
          {{! @glint-expect-error: Incorrect type }}
          @value={{@issue.base_rate}}
        />

        <div>
          <label class="input-label">{{t "rates.type"}}</label>
          <div class="checkbox flex items-center">
            <PrismCheckbox
              {{! @glint-expect-error: Incorrect type }}
              @checked={{@issue.base_cancellation}}
              {{! @glint-expect-error: Incorrect type }}
              @onChange={{fn @toggleValue "base_cancellation"}}
            >
              {{t "general.cancellable"}}
            </PrismCheckbox>
          </div>
        </div>
      </div>

      <div class="flex w-full flex-col">
        <PrismInput
          @label={{t "parity_manager.brand_room_name"}}
          @onInput={{this.updateBaseRoomName}}
          {{! @glint-expect-error: Incorrect type }}
          @value={{@issue.base_room_name}}
        />
      </div>

      <div class="grid grid-cols-2 gap-400">
        <GeneralFormsFormFieldsDatepickerFormField
          {{! @glint-expect-error: Incorrect type }}
          @datePickerMinDate={{this.minDate}}
          @label={{t "general.arrival_date"}}
          @onSelectDate={{this.onSelectionArrivalDate}}
          {{! @glint-expect-error: Incorrect type }}
          @selectedDate={{@issue.arrival_date}}
        />
        <div class="flex flex-col">
          <label class="input-label required-indicator">
            {{t "rates.los"}}
          </label>
          <PrismSelectInput
            @isSecondary={{true}}
            @onChange={{this.updateLos}}
            {{! @glint-expect-error: Incorrect type }}
            @options={{this.losOptions}}
            @unsafe_matchTriggerWidth={{true}}
            @value={{this.losValue}}
          />
        </div>
      </div>

      {{#if @isMajorOtaView}}
        <div class="grid grid-cols-2 gap-400">
          <div class="flex flex-col">
            <label class="input-label required-indicator">
              {{t "general.platform.plural" count=1}}
            </label>
            <PrismComboSelectInput
              @isSecondary={{true}}
              @onChange={{this.setSelectedPlatformId}}
              {{! @glint-expect-error: Incorrect type }}
              @options={{@platformOptions}}
              @value={{this.selectedPlatform}}
            />
          </div>
          <div class="flex flex-col">
            <label class="input-label required-indicator">
              {{t "parity.pos.pos"}}
            </label>
            <PrismComboSelectInput
              @isSearchable={{true}}
              @isSecondary={{true}}
              @onChange={{this.updatePos}}
              {{! @glint-expect-error: Incorrect type }}
              @options={{this.posOptions}}
              @placeholder={{t "parity.pos.pos"}}
              @value={{this.posValue}}
            />
          </div>
        </div>
      {{/if}}
    </div>

    <div class="settings-modal__footer flex justify-end">
      <GeneralFormFieldsCancelAndConfirm
        {{! @glint-expect-error: Incorrect type }}
        @cancel={{@cancel}}
        {{! @glint-expect-error: Incorrect type }}
        @confirm={{@next}}
        @confirmText={{t "general.next_step"}}
        @isConfirmDisabled={{not this.isFormValid}}
      />
    </div>
  </template>
}
